import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

// You can replace this with your actual logo image path
const logoUrl = "/logo.png";
const emailIcon = "/email-icon.svg";
const phoneIcon = "/phone-icon.svg";

const navLinks = [
  { to: "/", label: "HOME" },
  { to: "/about", label: "ABOUT US" },
  { to: "/services", label: "SERVICES" },
  { to: "/our-solutions", label: "SOLUTION" },
  { to: "/contact", label: "CONTACT US" },
];

const NavigationBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Responsive: Show hamburger on small screens
  const isMobile = typeof window !== "undefined" && window.innerWidth < 992;

  return (
    <>
      {/* Top Bar */}
      <div className="navbar-topbar">
        <div className="container">
          <div className="top-bar-wrapper">
            <div className="navbar-topbar-left">
              <img src={phoneIcon} alt="Phone" />
              <span>Phone: +971 2 123 4567</span>
            </div>
            <div className="navbar-topbar-right">
              <img src={emailIcon} alt="Email" />
              <span>Email:info@videovision.io</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className="navbar-main">
        <div className="navbar-container">
          {/* Logo */}
          <Link to="/" className="navbar-logo-link">
            <img src={logoUrl} alt="Logo" className="navbar-logo-img" />
          </Link>

          {/* Nav Links */}
          <div
            className={"navbar-links" + (isMobile && menuOpen ? " open" : "")}
            style={
              isMobile ? { display: menuOpen ? "flex" : "none" } : undefined
            }
          >
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={
                  "navbar-link" +
                  (location.pathname === link.to ? " active" : "")
                }
                onClick={() => {
                  if (isMobile) setMenuOpen(false);
                }}
              >
                {link.label}
              </Link>
            ))}
          </div>
          <div className="d-flex align-items-center gap-2">
            {/* <button className="main-btn red-btn">
              <span>Login/Signup</span>
            </button> */}
            {/* Hamburger for mobile */}
            <button
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="Toggle navigation"
              className="navbar-hamburger"
              style={{
                display: isMobile ? "flex" : "none",
              }}
            >
              <span className="navbar-hamburger-bar" />
              <span className="navbar-hamburger-bar" />
              <span className="navbar-hamburger-bar" />
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavigationBar;
